import React,{useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { sidebarAction } from '../redux/SidebarSlice'
import BreadCrames from '../component/BreadCrames';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import ApiConnection, { BaseUrl } from '../utils/ApiConnection';
import Loader from '../utils/Loader';
import moment from 'moment';
import { toast } from 'react-toastify';
import { GoogleMap, LoadScript, Marker, DirectionsService, DirectionsRenderer } from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';


const BookNewRide = () => {

  const [acceptmodal, setacceptmodal] = useState(false)
  const [declinemodal, setdeclinemodal] = useState(false)
  const [triplist, settriplist] = useState([])
  const [loading, setloading] = useState(false)
  const [rowId, setrowId] = useState('')
  const [reason, setreason] = useState('')
  const [amount, setamount] = useState('')
  const [directions, setDirections] = useState(null)
  const [isshow, setisshow] = useState(null)


    const dispatch = useDispatch()
    const GetTrip = async () =>{

      setloading(true)

      try {

          const response = await ApiConnection.get('trips?status=ongoing')
          setloading(false)
          if(response?.status === 200) {
              settriplist(response?.data?.data?.list)
          }

      } catch (e){  setloading(false)}

  }

    useEffect(()=>{
      GetTrip()
        dispatch(sidebarAction(false)) 
      },[])

      function Acceptmodal(id){
        setrowId(id)
        setacceptmodal(true)
      }

      function Declinemodal(id){
        setrowId(id)
        setdeclinemodal(true)
      }

      const AcceptSubmit = async (action) =>{
        if(action == 'accept'){
          if(amount == ''){
            toast.error('Fare is required')
          }     else {
            setloading(true)
              var FormData = require('form-data');
              var data = new FormData();
              data.append('id', rowId);
              data.append('action', 'completed');
              data.append('final_fare', amount);
              
  
              try{
                  const response = await ApiConnection.post('trips/change-status', data)
                  setloading(false)
                  if(response?.data?.success){
                      setacceptmodal(false)
                      toast.success(response?.data?.message)
                      GetTrip()
                  }
  
              } catch(e){  setloading(false)}
          }
        } else {
          if(reason == ''){
            toast.error('Reason is required')
          }    else {
            setloading(true)
              var FormData = require('form-data');
              var data = new FormData();
              data.append('id', rowId);
              data.append('action', action);
              data.append('val', reason);
              
  
              try{
                  const response = await ApiConnection.post('trips/change-status', data)
                  setloading(false)
                  if(response?.data?.success){
                      setdeclinemodal(false)
                      toast.success(response?.data?.message)
                      GetTrip()
                  }
  
              } catch(e){  setloading(false)}
          }
        }
      
    
      }

    
      const containerStyle = {
        width: '100%',
        height: '200px',
      };

   

    

      function ViewHandle (id, plat, plng, dlat, dlng){

        var origin = {lat:plat, lng: plng }
        var destination = {lat:dlat, lng: dlng }

        setisshow(id)
        if (origin && destination) {
          const directionsService = new window.google.maps.DirectionsService();
          directionsService.route(
            {
              origin: origin,
              destination: destination,
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === window.google.maps.DirectionsStatus.OK) {
                setDirections(result);
              } else {
                console.error(`error fetching directions ${result}`);
              }
            }
          );
        }
      }

      const navigate = useNavigate();

      const getGoogleMapsUrl = (startLocation, endLocation) => {
        const baseUrl = 'https://www.google.com/maps/dir/';
        const url = `${baseUrl}${encodeURIComponent(startLocation)}/${encodeURIComponent(endLocation)}`;
        return url;
      };

      const handleGetDirections = (startLocation, endLocation) => {
     
        const mapsUrl = getGoogleMapsUrl(startLocation, endLocation);
        
        // Redirect to Google Maps
        window.open(mapsUrl, '_blank');
      };




  return (
    <>
   
       {loading && <Loader/>}
    <BreadCrames page="Ongoing Ride" />
    <div className='px-4'>
      {triplist&&triplist.length > 0 ?
      

    <div className='row'>
      {triplist&&triplist.map((item, index)=>{
        return (
          <div className='col-lg-6' key={index}>
          <div className='card mb-3'>
            <div className='card-body'>
                      <p>
                        <b>Name: </b>
                        {item?.customer?.first_name} {item?.customer?.last_name} ({item?.customer?.phone})                                                     
                      </p>
                      <p>
                        <b>Pickup Location: </b>
                        {item?.pickup_location}                                                        
                      </p>
                      <p>
                        <b>Date & Time of Pickup: </b>
                        {moment(item?.pickup_date).format('DD-MM-YYY LT')}                                                     
                      </p>
                      <p>
                        <b>Drop Location: </b>
                       {item?.drop_location}                                                      
                      </p>
                      <p>
                        <b>Car Type: </b>
                       {item?.cartype}                                                      
                      </p>

<b>Cutomer Details: </b>
                        <div className='customer-details'>
                          {item?.
customer?.image == null ?
<FontAwesomeIcon icon={faUserTie} />
:
<img src={BaseUrl + item?.
customer?.image} />
}
                       
                        <h5>{item?.
customer?.first_name + ' ' + item?.
customer?.last_name} ({item?.
  customer?.country_code +' ' + item?.
  customer?.phone})</h5>
                          </div>

                      {item?.has_trip_started !== 0 &&

<button className='btn btn-info btn-sm mb-2'  onClick={()=>Acceptmodal(item?.id)}>Mark as Trip Completed</button>

}
                      {/* <button className='btn btn-info btn-sm'  onClick={()=>Acceptmodal(item?.id)}>Accept</button>
                      <button className='btn btn-danger btn-sm ml-2' onClick={()=>Declinemodal(item?.id)} >Declined</button> */}
                      <button className='btn btn-danger btn-sm ml-2 mb-2' onClick={()=>ViewHandle(item?.id, Number(item?.pickup_lat),
                      Number(item?.pickup_long),Number(item?.drop_lat), Number(item?.drop_long)
                      
                      )} >View</button>
                       <button className='btn btn-sm btn-warning mb-2 ml-2' onClick={()=>handleGetDirections(item?.pickup_location, item?.drop_location)}>Get Directions</button>

                      {
                        isshow == item.id && 
                   
                        <GoogleMap mapContainerStyle={containerStyle}  center={{
                          lat: (Number(item?.pickup_lat) + Number(item?.drop_lat)) / 2,
                          lng: (Number(item?.pickup_long) + Number(item?.drop_long)) / 2,
                        }} zoom={9}>
                                      {/* <Marker position={{lat:Number(item?.pickup_lat), lng:Number(item?.pickup_long)}} />
                                      <Marker position={{lat:Number(item?.drop_lat), lng:Number(item?.drop_long)}} /> */}
                                      <DirectionsRenderer directions={directions} />
                                     
                                    </GoogleMap>
                                  
                      }
                  </div>
              
                </div>
            </div>
        )
      })}
  
      
      
      </div>
      :
      <h5>No Trip list</h5>
}
      {/* <div className='table-responsive'>
        <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>Name</th>
          <th>Pickup Location</th>
          <th>Date & Time of Pickup</th>
          <th>Drop Location</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Mark</td>
          <td>Otto</td>
          <td>@mdo</td>
          <td>
            <button className='btn btn-info btn-sm'>Accept</button>
            <button className='btn btn-danger btn-sm ml-2'>Declined</button>
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>Jacob</td>
          <td>Thornton</td>
          <td>@fat</td>
        </tr>
        <tr>
          <td>3</td>
          <td colSpan={2}>Larry the Bird</td>
          <td>@twitter</td>
        </tr>
      </tbody>
    </Table>
    </div> */}
    </div>
    <Modal
      show={acceptmodal}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
        Accept Trip
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          <div className='form-group mb-4'>
              <label>Enter Estimated Fare</label>
              <input type='text' className='form-control' placeholder='Amount' 
              value={amount}
              onChange={(e)=>setamount(e.target.value)}
              />
          </div>
          <div className='form-group text-right'>
              <button className='btn bt-sm btn-dark' onClick={()=>setacceptmodal(false)}>Cancel</button>
              <button className='btn bt-sm btn-primary ml-2' onClick={()=>AcceptSubmit('accept')}>Submit</button>
          </div>
      </Modal.Body>
   
    </Modal>
    <Modal
      show={declinemodal}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
        Decline Trip
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          <div className='form-group mb-4'>
              <label>Enter Decline Reason</label>
              <input type='text' className='form-control' placeholder='Reason'
              value={reason}
              onChange={(e)=>setreason(e.target.value)}
              />
          </div>
          <div className='form-group text-right'>
              <button className='btn bt-sm btn-dark' onClick={()=>setdeclinemodal(false)}>Cancel</button>
              <button className='btn bt-sm btn-primary ml-2' onClick={()=>AcceptSubmit('declined')}>Submit</button>
          </div>
      </Modal.Body>
   
    </Modal>
  
</>
  )
}

export default BookNewRide